
export default function Footer() {
  return (
    <footer className="bg-slate-800 border-t border-slate-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              AssessorLink
            </h3>
            <p className="text-slate-400 mb-6 max-w-md">
              Your comprehensive directory for county assessor offices and appraisal districts across all 50 states. 
              Find property records, tax assessments, and valuation data instantly.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-slate-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="/" className="text-slate-400 hover:text-white transition-colors cursor-pointer">Home</a></li>
              <li><a href="/states" className="text-slate-400 hover:text-white transition-colors cursor-pointer">Browse States</a></li>
              <li><a href="/search" className="text-slate-400 hover:text-white transition-colors cursor-pointer">Search</a></li>
              <li><a href="/resources" className="text-slate-400 hover:text-white transition-colors cursor-pointer">Resources</a></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-white font-semibold mb-4">Support</h4>
            <ul className="space-y-2">
              <li><a href="/contact" className="text-slate-400 hover:text-white transition-colors cursor-pointer">Contact Us</a></li>
              <li><a href="/help" className="text-slate-400 hover:text-white transition-colors cursor-pointer">Help Center</a></li>
              <li><a href="/privacy" className="text-slate-400 hover:text-white transition-colors cursor-pointer">Privacy Policy</a></li>
              <li><a href="/terms" className="text-slate-400 hover:text-white transition-colors cursor-pointer">Terms of Service</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-slate-400 text-sm">
            © 2024 AssessorLink. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0">
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-slate-400 hover:text-white text-sm transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
